import styled, { css } from "styled-components";
import { getThemeSpace } from "../helpers";
export const Box = styled.div `
	display: flex;
	flex-shrink: 0;
	justify-content: center;
	align-items: center;

	border: 1px solid var(--surface-accent-dark);
	border-radius: 4px;
	background-color: var(--surface-white);
	padding: 0;

	width: 24px;
	height: 24px;

	cursor: pointer;

	${({ size }) => size === "small" && css `
		width: 16px;
		height: 16px;
		border-radius: 2px;
	`}

	${({ disabled }) => disabled &&
    css `
			background-color: var(--surface-primary);
			border-color: var(--border-primary);
			cursor: not-allowed;
			color: var(--text-primary);
		`}

	i {
		pointer-events: none;
	}
`;
export const LabelField = styled.label `
	display: flex;
	gap: ${getThemeSpace("8")};

	input[type='checkbox'] {
		flex-shrink: 0;
		width: 0;
		height: 0;
		padding: 0;
		margin: 0;
		opacity: 0;
		margin-left: -${getThemeSpace("8")};
	}

	${({ disabled }) => disabled &&
    css `
			pointer-events: none;
		`}
`;
//# sourceMappingURL=styles.js.map